import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { partnerLifestyleAppearanceDetailEditSchema } from '../../../ValidationSchema';
import { editPartnerLifestyleAppearance, getAllPhysicalStatus } from '../../../../asiosConfig';
import { toast, ToastContainer } from 'react-toastify';
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { Autocomplete, Button, Card, CardContent, CardHeader, Chip, MenuItem, TextField } from '@mui/material';

export const PartnerLifestyleAppearanceEdit = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const userProfileData = location.state?.userProfileData || {};
    const [physicalStatus, setPhysicalStatus] = useState([]);
    const [eatingHabits, setEatingHabits] = useState([]);
    const [drinkingHabits, setDrinkingHabits] = useState([]);
    const [smokingHabits, setSmokingHabits] = useState([]);
    const [complexion, setComplexion] = useState([]);

    const eatingHabitsArray = userProfileData.partnerEatingHabits
        ? userProfileData.partnerEatingHabits.split(',').map((item) => item.trim())
        : [];
    const bodyComplexionArray = userProfileData.partnerComplexion
        ? userProfileData.partnerComplexion.split(',').map((item) => item.trim())
        : [];

    const formik = useFormik({
        initialValues: {
            partner_eating_Habits: eatingHabitsArray,
            // partner_physical_status: userProfileData.partnerPhysicalStatus || '',
            partner_drinking_habits: userProfileData.partner_drinking_habits || '',
            partner_smoking_habits: userProfileData.partner_smoking_habits || '',
            partnerComplexion: bodyComplexionArray || [],
            // tokan: localStorage.getItem('token'),
        },
        validationSchema: partnerLifestyleAppearanceDetailEditSchema,
        onSubmit: async (values, { setSubmitting }) => {
            try {
                const formattedValues = {
                    ...values,
                    partner_eating_Habits: values.partner_eating_Habits.join(','), // Convert back to string
                    partnerComplexion: values.partnerComplexion.join(','), // Convert back to string
                };
                const response = await editPartnerLifestyleAppearance(formattedValues);
                if (response.status === 200 || response.status === 201) {
                    toast.success(response?.data?.message);
                    setTimeout(() => {
                        navigate(-1);
                    }, 3000);
                } else {
                    toast.error(response?.data?.message)
                }
            } catch (error) {
                toast.error(error.response?.data?.message);
            } finally {
                setSubmitting(false);
            }
        },
    });

    useEffect(() => {
        const fetchAllStatus = async () => {
            try {
                const response = await getAllPhysicalStatus();
                if (response.status === 200 || response.status === 201) {
                    setPhysicalStatus(response.data.data.physical_status);
                    setEatingHabits(response.data.data.eating_habit);
                    setDrinkingHabits(response.data.data.drink);
                    setSmokingHabits(response.data.data.smoke);
                    setComplexion(response.data.data.body_complexion);
                }
            } catch (error) {
                toast.error(error.message);
            }
        }
        fetchAllStatus();
    }, []);
    return (
        <div className="col-lg-9 col-12">
            <Card className='editProfileBlock'>
                <CardHeader
                    avatar={
                        <ArrowBackIcon sx={{ color: '#FF8008' }} onClick={() => navigate(-1)} />
                    }
                    title="Partner's Lifestyle and Appearance"
                    subheader='Update Your Partner LifeStyle and Appearance to get suitable matches'
                    titleTypographyProps={{ sx: { color: '#FF8008', fontSize: '20px', fontWeight: '500' } }}
                />
                <CardContent>
                    <form onSubmit={formik.handleSubmit}>
                        <div className="row">
                            {/* <div className="col-md-6">
                                <TextField
                                    fullWidth
                                    select
                                    label="Physical Status"
                                    variant="outlined"
                                    className="mb-3"
                                    name="partner_physical_status"
                                    value={formik.values.partner_physical_status}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.partner_physical_status && Boolean(formik.errors.partner_physical_status)}
                                    helperText={formik.touched.partner_physical_status && formik.errors.partner_physical_status}
                                >
                                    <MenuItem value=''>Select Physical Status</MenuItem>
                                    <MenuItem value={-1}>Doesn't Matter</MenuItem>
                                    {physicalStatus.map((value, index) => (
                                        <MenuItem key={index} value={value.id}>{value.Type}</MenuItem>
                                    ))}
                                </TextField>

                            </div> */}
                            <div className="col-md-6">
                                <Autocomplete
                                    multiple
                                    options={[{ id: -1, type: "Doesn't Matter" }, ...complexion]} // Add "Doesn't Matter" option
                                    className='mb-3'
                                    getOptionLabel={(option) => option.type}
                                    value={
                                        formik.values.partnerComplexion.includes("-1")
                                            ? [{ id: -1, type: "Doesn't Matter" }] // If "Doesn't Matter" is selected, only show that
                                            : complexion.filter(comp => formik.values.partnerComplexion.includes(String(comp.id))) // Show selected complexions
                                    }
                                    onChange={(event, newValue) => {
                                        if (newValue.some(item => item.id === -1)) {
                                            // If "Doesn't Matter" is selected, clear all other selections
                                            formik.setFieldValue('partnerComplexion', ['-1']);
                                        } else {
                                            // Otherwise, remove "Doesn't Matter" if selected and add other selections
                                            formik.setFieldValue(
                                                'partnerComplexion',
                                                newValue.map((item) => String(item.id)).filter(id => id !== '-1')
                                            );
                                        }
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Partner Complexion"
                                            variant="outlined"
                                            error={formik.touched.partnerComplexion && Boolean(formik.errors.partnerComplexion)}
                                            helperText={formik.touched.partnerComplexion && formik.errors.partnerComplexion}
                                        />
                                    )}
                                    renderTags={(value, getTagProps) =>
                                        value.map((option, index) => (
                                            <Chip
                                                label={option.type}
                                                onDelete={() => formik.setFieldValue('partnerComplexion', formik.values.partnerComplexion.filter(id => id !== String(option.id)))}
                                                {...getTagProps({ index })}
                                                key={option.id}
                                            />
                                        ))
                                    }
                                />
                            </div>

                            <div className="col-md-6">
                                <Autocomplete
                                    multiple
                                    options={[{ id: -1, Type: "Doesn't Matter" }, ...eatingHabits]}
                                    className='mb-3'
                                    getOptionLabel={(option) => option.Type}
                                    value={formik.values.partner_eating_Habits.includes("-1")
                                        ? [{ id: -1, Type: "Doesn't Matter" }] // If "Doesn't Matter" is selected, display only that
                                        : eatingHabits.filter(eat => formik.values.partner_eating_Habits.includes(String(eat.id)))}
                                    onChange={(event, newValue) => {
                                        if (newValue.some(item => item.id === -1)) {
                                            // If "Doesn't Matter" is selected, clear all other selections
                                            formik.setFieldValue('partner_eating_Habits', ['-1']);
                                        } else {
                                            // Otherwise, remove "Doesn't Matter" if selected and add other selections
                                            formik.setFieldValue(
                                                'partner_eating_Habits',
                                                newValue.map((item) => String(item.id)).filter(id => id !== '-1')
                                            );
                                        }
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Partner Eating Habits"
                                            variant="outlined"
                                            error={formik.touched.partner_eating_Habits && Boolean(formik.errors.partner_eating_Habits)}
                                            helperText={formik.touched.partner_eating_Habits && formik.errors.partner_eating_Habits}
                                        />
                                    )}
                                    renderTags={(value, getTagProps) =>
                                        value.map((option, index) => (
                                            <Chip
                                                label={option.Type}
                                                onDelete={() => formik.setFieldValue('partner_eating_Habits', formik.values.partner_eating_Habits.filter(id => id !== String(option.id)))}
                                                {...getTagProps({ index })}
                                                key={option.id}
                                            />
                                        ))
                                    }
                                />
                            </div>


                            <div className="col-md-6">
                                <TextField
                                    fullWidth
                                    select
                                    label="Drinking Habits"
                                    variant="outlined"
                                    className="mb-3"
                                    name="partner_drinking_habits"
                                    value={formik.values.partner_drinking_habits}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.partner_drinking_habits && Boolean(formik.errors.partner_drinking_habits)}
                                    helperText={formik.touched.partner_drinking_habits && formik.errors.partner_drinking_habits}
                                >
                                    <MenuItem value="">Select Drinking Habits</MenuItem>
                                    <MenuItem value={-1}>Doesn't Matter</MenuItem>
                                    {drinkingHabits.map((value, index) => (
                                        <MenuItem key={index} value={value.id}>
                                            {value.Type}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </div>
                            <div className="col-md-6">
                                <TextField
                                    fullWidth
                                    select
                                    label="Smoking Habits"
                                    variant="outlined"
                                    className="mb-3"
                                    name="partner_smoking_habits"
                                    value={formik.values.partner_smoking_habits}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.partner_smoking_habits && Boolean(formik.errors.partner_smoking_habits)}
                                    helperText={formik.touched.partner_smoking_habits && formik.errors.partner_smoking_habits}
                                >
                                    <MenuItem value="">Select Smoking Habits</MenuItem>
                                    <MenuItem value={-1}>Doesn't Matter</MenuItem>
                                    {smokingHabits.map((value, index) => (
                                        <MenuItem key={index} value={value.id}>
                                            {value.Type}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </div>
                        </div>
                        {/* <div className="d-grid col-4 mx-auto mt-2"> */}
                            <Button type="submit" variant="contained" sx={{ backgroundColor: '#FF8008' }}>
                                {formik.isSubmitting ? 'Saving...' : 'Save Changes'}
                            </Button>
                        {/* </div> */}
                    </form>
                </CardContent>
            </Card>
            <ToastContainer />
        </div>
    )
}
